export default "__VITE_ASSET__CvSByzgA__"